import React, {Component} from 'react';
import {connect} from 'react-redux';

import template from '../../../templates/PageLayout/Popups/QuestionPopup.rt';
import {setQuestionPopupState} from "../../../actions/A_Popups";

class QuestionPopup extends Component {

  handleYesClick = () => {
    if (this.props.questionPopupState.yesClick) {
      this.props.questionPopupState.yesClick();
    }
    this.handleClose();
  }

  handleNoClick = () => {
    if (this.props.questionPopupState.noClick) {
      this.props.questionPopupState.noClick();
    }
    this.handleClose();
  }

  handleClose = () => {
    this.props.setQuestionPopupState({
      className: "",
      showPopup: false,
      questionMessage: "",
      yesClick: null,
      noClick: null,
    })
  }

  render = template;
}

const mapStateToProps = (state) => ({
  questionPopupState: state.popups.questionPopupState
});

const mapDispatchToProps = {setQuestionPopupState};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionPopup);
